import { Model } from "vuex-fetch-factory";
import { PostManualRequest } from "../api";

export interface ManualRaw {
  id: number;
  name: string;
  description: string;
  tags: string[] | null;
  thumbnail: string;
  download_link: string;
  all_relations?: boolean;
  root_relation_type_ids?: number[] | null;
  no_project_filter?: boolean;
  project_filters?: string[] | null;
}

export class ManualModel implements Model<ManualModel, ManualRaw> {
  public id = 0;
  public name = "";
  public description = "";
  public tags: string[] | null = [];
  public thumbnail = "";
  public download_link = "";
  public all_relations: undefined | boolean = true;
  public root_relation_type_ids: undefined | null | number[] = [];
  public no_project_filter: undefined | boolean = true;
  public project_filters: undefined | null | string[] = [];

  public getNew(): ManualModel {
    return new ManualModel();
  }

  public fillModel(raw: ManualRaw): this {
    this.id = raw.id;
    this.name = raw.name;
    this.description = raw.description;
    this.tags = raw.tags;
    this.thumbnail = raw.thumbnail;
    this.download_link = raw.download_link;
    this.all_relations = raw.all_relations;
    this.root_relation_type_ids = raw.root_relation_type_ids || [];
    this.no_project_filter = raw.no_project_filter;
    this.project_filters = raw.project_filters || [];
    return this;
  }

  public getRaw(): ManualRaw {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      tags: this.tags,
      thumbnail: this.thumbnail,
      download_link: this.download_link,
      all_relations: this.all_relations,
      root_relation_type_ids: this.root_relation_type_ids,
      no_project_filter: this.no_project_filter,
      project_filters: this.project_filters,
    };
  }

  public getIPostManualRequest(extension?: string): PostManualRequest {
    return {
      name: this.name,
      description: this.description,
      tags: this.tags,
      all_relations: this.all_relations || false,
      root_relation_type_ids: this.all_relations
        ? null
        : this.root_relation_type_ids || null,
      no_project_filter: this.no_project_filter || false,
      project_filters: this.no_project_filter
        ? null
        : this.project_filters || null,
      extension,
    };
  }

  public getCopy(): ManualModel {
    return new ManualModel().fillModel(this.getRaw());
  }
}
